import Repository from "./Repository";

//const resource = '/auth';

export default {
  Consultar_esquema(data) {
    return Repository.post(`/negocio/consulta-entidad`, data);
  },
  Consultar_esquema_filtros(data) {
    return Repository.post(`/negocio/consulta-entidad-filtros`, data);
  },
  Guardar_esquema(data) {
    return Repository.post(`/negocio/guardar-entidad`, data);
  },
  Mostrar_esquema_id(data) {
    return Repository.post(`/negocio/consulta-entidad-id`, data);
  },
  Actualizar_esquema(data) {
    return Repository.post(`/negocio/actualizar-entidad`, data);
  },
  Crear_entidad(data) {
    return Repository.post(`/negocio/crear-entidad`, data);
  },
  Guardar_dato_entidad(data) {
    return Repository.post(`/negocio/guardar-entidad`, data);
  },
  Consultar_datos_entidad(data) {
    return Repository.post(`/negocio/consulta-entidad`, data);
  },
  Consultar_filtros_dato_entidad(data) {
    return Repository.post(`/negocio/consulta-entidad-filtros`, data);
  },
  Actualizar_dato_entidad(data) {
    return Repository.post(`/negocio/actualizar-entidad`, data);
  },
  Mostrar_esquema_query_pag(data) {
    return Repository.post(`/negocio/get-query-by-entidades-v4-jsonb`, data);
  },
  Mostrar_esquema_names(data) {
    return Repository.post(`/negocio/consulta-entidad-names-schema`, data);
  },
  Establecer_permisos_Acciones() {
    return Repository.post(`/usuario/PerfilPermisos/menus`);
  },
  Establecer_permisos_Url(data) {
    return Repository.post(`/usuario/PerfilPermisos/menus_validation`, data);
  },
  Consultar_Esquema_QR() {
    return Repository.post(`/negocio/login/mfa/setup`);
  },
  Validar_Primer_Codigo(data) {
    return Repository.post(`/negocio/login/mfa/verify-setup`, data);
  },
  Validar_codigo(data) {
    return Repository.post(`/negocio/login/mfa/validate`, data);
  },
  Borrar_Registro(data) {
    return Repository.post(`/negocio/eliminar-tupla-entidad`, data);
  },
  Mostrar_Datos_Auditoria(data) {
    console.log("data", data);
    return Repository.post(`/negocio/get-query-by-audit`, data);
  },
  Crear_Nuevo_Usuario(data) {
    return Repository.post(`/negocio/user/registerpass`, data);
  },

};
